// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import DiscountIcon from '@mui/icons-material/Discount';
import moment from 'moment';

const DiscountBandAssignmentTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="DiscountBandAssignment"
      pageIcon={DiscountIcon}
      addButtonLabel="AddNewDiscountBandAssignment"
      
      // ============ NAVIGATION URLs ============
      addPageUrl="/fare-products/discount-band-assignment/new"
      viewPageUrl="/fare-products/discount-band-assignment/:id"
      editPageUrl="/fare-products/discount-band-assignment/:id/edit?came_from=all"
      
      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment`}
      getApiMethod="GET"
      
      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment/:id`}
      deleteApiMethod="PATCH" 
      deleteBody={{ is_active: false }}
      
      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.discountBandAssignments"
      responsePaginationPath="data.data.pagination"
      
      // ============ TABLE CONFIGURATION ============
      idField="discount_band_assignments_id"
      columns={[
        {
          field: 'org_en_name',
          headerKey: 'Organisation',
          align: 'center',
          render: (value, row) => currentLanguageCode === 'en-us' ? row.org_en_name : row.org_ar_name,
        },
        {
          field: 'discount_band_name',
          headerKey: 'DiscountBand',
          align: 'center',
          sortable: true,
          sortField: 'db.name',
        },
        {
          field: 'passengers_group_name',
          headerKey: 'PassengersGroup',
          align: 'center',
          sortable: true,
          sortField: 'pg.name',
        },
        {
          field: 'assigned_routes',
          headerKey: 'Routes',
          align: 'center',
          render: (value, row) => {
            if (!value || value.length === 0) return '-';
            return value.map((r: any) => 
              currentLanguageCode === 'en-us' ? r.en_name : r.ar_name
            ).join(', ');
          },
        },
        {
          field: 'priority',
          headerKey: 'Priority',
          align: 'center',
          sortable: true,
          sortField: 't.priority',
        },
        {
          field: 'valid_from',
          headerKey: 'ValidFrom',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY') : '-',
          sortable: true,
          sortField: 't.valid_from',
        },
        {
          field: 'valid_to',
          headerKey: 'ValidTo',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY') : '-',
          sortable: true,
          sortField: 't.valid_to',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
          sortable: true,
          sortField: 't.created_at',
        },
      ]}
      
      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchDiscountBandAssignmentPlaceholder"
      searchInputWidth="470px"
      
      filterFields={[
        {
          name: 'organisations_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
        {
          name: 'discount_bands_id',
          labelKey: 'DiscountBand',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band`,
          apiMethod: 'GET',
          dataPath: 'data.data.discountBands',
          optionConfig: {
            valueField: 'discount_bands_id',
            labelField: 'name',
          },
        },
        {
          name: 'passengers_groups_id',
          labelKey: 'PassengersGroup',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/passengers_groups`,
          apiMethod: 'GET',
          dataPath: 'data.data.passengersGroups',
          optionConfig: {
            valueField: 'passengers_groups_id',
            labelField: 'name',
          },
        },
        {
          name: 'routes_id',
          labelKey: 'Route',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment/routes`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
      ]}
      
      // ============ PERMISSIONS ============
      subsystemName="DiscountBandAssignment"
      permissionSystem="fares"
      
      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteDiscountBandAssignment"
    />
  );
};

export default DiscountBandAssignmentTable;
